import styled from 'styled-components';
import { outlineGray } from '../../../../config/colors';
import { TILE_HEIGHT, TILE_WIDTH } from '../consts';

export const Wrapper = styled.div`
  position: absolute;
  display: flex;
`;

export const Box = styled.div`
  height: ${TILE_HEIGHT * 0.75}px;
  width: ${TILE_WIDTH * 5}px;
  outline: 1px solid ${outlineGray};
  background-color: white;
  opacity: 0.7;
`;
